import { useSearchParams } from 'next/navigation';
import { JSX } from 'react';
import { getSearchUrl, SearchOrigins } from 'search-gateway-client/components';

import { Text } from '@videoblocks/design-system';
import { AudioStockItem, TopTag } from '@videoblocks/search-gateway-client';

import './AudioTopTags.css';

type Props = {
    stockItem: AudioStockItem;
    openDetailsInNewWindow?: boolean;
};

const sortByTagPosition = (tagOne: TopTag, tagTwo: TopTag) => tagOne.tagPosition - tagTwo.tagPosition;

const AudioTopTags = ({ stockItem, openDetailsInNewWindow }: Props): JSX.Element | null => {
    const { nestedTopTags = [] } = stockItem;
    const searchParams = useSearchParams();
    if (!nestedTopTags.length) return null;

    const sortedTags = [...nestedTopTags].sort(sortByTagPosition).filter((tag) => tag.tagName);

    return (
        <div className="flex flex-wrap w-full h-5 overflow-hidden text-sm leading-5 text-blue-700 font-semibold">
            {sortedTags.map((tag) => {
                const { tagName, tagUrlId } = tag;

                return (
                    <Text asChild fontSize="sm" fontWeight="semibold" key={tagName}>
                        <span className="tag-wrapper">
                            <a
                                className="hover:underline"
                                href={getSearchUrl(
                                    {
                                        contentType: stockItem.contentType,
                                        categoryUrlIds: [tagUrlId],
                                        searchOrigin: SearchOrigins.STOCK_ITEM_CARD,
                                    },
                                    searchParams,
                                )}
                                target={openDetailsInNewWindow ? '_blank' : '_self'}
                            >
                                {tagName}
                            </a>
                        </span>
                    </Text>
                );
            })}
        </div>
    );
};

export default AudioTopTags;
